import React from "react";
import "./App.css";
import { Switch, Route } from "react-router-dom";
import CreateAccount from "./Views/CreateAccount/CreateAccounts";
import Founders from "./Views/Founders/Founders";
import HyperLocalNetworks from "./Views/HyperLocalNetworks/HyperLocalNetworks";
import Industry from "./Views/Industry/Industry";
import MatchingIndustry from "./Views/MatchingIndustry/MatchingIndustry";
import RevenueForm from "./Views/RevenueForm/RevenueForm";
import PolicyAgreement from "./Views/PolicyAgreement/PolicyAgreement";
import Payment from "./Views/Payment/Payment";
import Welcome from "./Views/Welcome/Welcome";
import MatchingRevenue from "./Views/MatchingRevenue/MatchingRevenue";
import Availability from "./Views/Availability/Availability";
import Dashboard from "./Views/Dashboard/Dashboard";
import Login from "./Views/Login/Login";
import OtherCity from "./Views/OtherCity/OtherCity";
import ErrorPage from "./Views/ErrorPage/ErrorPage";
import NotInBusiness from "./Views/NotInBusiness/NotInBusiness";
import NotFound from "./Views/NotFound/NotFound";
import PaymentAccepted from "./Views/PaymentAccepted/PaymentAccepted";
import Goal from "./Views/Goal/Goal";
import AccountLinks from "./Views/AccountLinks/AccountLinks";
// import PageLoader from "./Components/PageLoader/PageLoader";
// import Starter from "./Views/Starter/Starter";
import GoalMatch from "./Views/GoalMatch/GoalMatch";
import VerifyEmail from "./Views/VerifyEmail/VerifyEmail";
import VerifyEmailCode from "./Views/VerifyEmailCode/VerifyEmailCode";
import GooLoader from "./Components/GooLoader/GooLoader";
// import TestPage from "./Views/TestPage/TestPage";

class App extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      user_type: "",
      city: "",
      otherCity: "",
      first_policy: false,
      second_policy: false,
      third_policy: false,
      matching_criteria_1: "",
      matching_criteria_2: {
        value: "",
        backendValue: "",
      },
      matching_criteria_3: "",
      matching_criteria_4: {
        value: "",
        backendValue: "",
      },
      matching_criteria_5: "",
      matching_criteria_6: {
        value: "",
        backendValue: "",
      },
      matching_criteria_7: "",
    };

    this.setUserType = this.setUserType.bind(this);
    this.setCity = this.setCity.bind(this);
    this.setOtherCity = this.setOtherCity.bind(this);
    this.setFirstPolicy = this.setFirstPolicy.bind(this);
    this.setSecondPolicy = this.setSecondPolicy.bind(this);
    this.setThirdPolicy = this.setThirdPolicy.bind(this);
    this.setMatchingCriteria1 = this.setMatchingCriteria1.bind(this);
    this.setMatchingCriteria2 = this.setMatchingCriteria2.bind(this);
    this.setMatchingCriteria3 = this.setMatchingCriteria3.bind(this);
    this.setMatchingCriteria4 = this.setMatchingCriteria4.bind(this);
    this.setMatchingCriteria5 = this.setMatchingCriteria5.bind(this);
    this.setMatchingCriteria6 = this.setMatchingCriteria6.bind(this);
    this.setMatchingCriteria7 = this.setMatchingCriteria7.bind(this);
    this.resetState = this.resetState.bind(this);
  }

  setUserType(userType) {
    this.setState({
      user_type: userType,
    });
  }

  setCity(city) {
    this.setState({
      city: city,
    });
  }

  setOtherCity(otherCity) {
    this.setState({
      otherCity: otherCity,
    });
  }

  setFirstPolicy(first_policy) {
    this.setState({
      first_policy: first_policy,
    });
  }

  setSecondPolicy(second_policy) {
    this.setState({
      second_policy: second_policy,
    });
  }

  setThirdPolicy(third_policy) {
    this.setState({
      third_policy: third_policy,
    });
  }

  setMatchingCriteria1(value) {
    this.setState({
      matching_criteria_1: value,
    });
  }

  setMatchingCriteria2(value, backendValue) {
    this.setState({
      matching_criteria_2: {
        value: value,
        backendValue: backendValue,
      },
    });
  }

  setMatchingCriteria3(value) {
    this.setState({
      matching_criteria_3: value,
    });
  }

  setMatchingCriteria4(value, backendValue) {
    this.setState({
      matching_criteria_4: {
        value: value,
        backendValue: backendValue,
      },
    });
  }

  setMatchingCriteria5(value) {
    this.setState({
      matching_criteria_5: value,
    });
  }

  setMatchingCriteria6(value, backendValue) {
    this.setState({
      matching_criteria_6: {
        value: value,
        backendValue: backendValue,
      },
    });
  }

  setMatchingCriteria7(value) {
    this.setState({
      matching_criteria_7: value,
    });
  }

  resetState() {
    this.setState({
      user_type: "",
      city: "",
      otherCity: "",
      first_policy: "",
      second_policy: "",
      matching_criteria_1: "",
      matching_criteria_2: {
        value: "",
        backendValue: "",
      },
      matching_criteria_3: "",
      matching_criteria_4: {
        value: "",
        backendValue: "",
      },
      matching_criteria_5: "",
      matching_criteria_6: {
        value: "",
        backendValue: "",
      },
      matching_criteria_7: "",
    });
  }

  render() {
    return (
      <div className="App">
        <Switch>
          <Route path="/" component={Login} exact />
          <Route path="/create-account" component={CreateAccount} exact />
          <Route path="/verify-email" component={VerifyEmail} exact />
          <Route path="/verification/:id" component={VerifyEmailCode} exact />
          <Route path="/error" component={ErrorPage} exact />
          <Route
            path="/for-founders-by-founders"
            render={() => (
              <Founders
                user_type={this.state.user_type}
                setUserType={this.setUserType}
              />
            )}
            exact
          />
          <Route path="/not-in-business" component={NotInBusiness} exact />
          <Route
            path="/hyperlocal-networks"
            render={() => (
              <HyperLocalNetworks
                setCity={this.setCity}
                city={this.state.city}
                otherCity={this.state.otherCity}
                setOtherCity={this.setOtherCity}
              />
            )}
            exact
          />
          <Route
            path="/hyperlocal-networks/other-city"
            component={OtherCity}
            exact
          />
          <Route
            path="/policy-agreement"
            render={() => (
              <PolicyAgreement
                first_policy={this.state.first_policy}
                second_policy={this.state.second_policy}
                setFirstPolicy={this.setFirstPolicy}
                setSecondPolicy={this.setSecondPolicy}
                third_policy={this.state.third_policy}
                setThirdPolicy={this.setThirdPolicy}
              />
            )}
            exact
          />
          <Route path="/payment" component={Payment} exact />
          <Route path="/payment-accepted" component={PaymentAccepted} exact />
          <Route path="/welcome" component={Welcome} exact />
          <Route
            path="/matching-criteria-1"
            render={() => (
              <MatchingIndustry
                matching_criteria_1={this.state.matching_criteria_1}
                setMatchingCriteria1={this.setMatchingCriteria1}
              />
            )}
            exact
          />
          <Route
            path="/matching-criteria-2"
            render={() => (
              <Industry
                matching_criteria_2={this.state.matching_criteria_2}
                setMatchingCriteria2={this.setMatchingCriteria2}
              />
            )}
            exact
          ></Route>
          <Route
            path="/matching-criteria-3"
            render={() => (
              <RevenueForm
                matching_criteria_3={this.state.matching_criteria_3}
                setMatchingCriteria3={this.setMatchingCriteria3}
              />
            )}
            exact
          ></Route>
          <Route
            path="/matching-criteria-4"
            render={() => (
              <MatchingRevenue
                matching_criteria_4={this.state.matching_criteria_4}
                setMatchingCriteria4={this.setMatchingCriteria4}
              />
            )}
            exact
          ></Route>
          <Route
            path="/matching-criteria-5"
            render={() => (
              <Goal
                matching_criteria_5={this.state.matching_criteria_5}
                setMatchingCriteria5={this.setMatchingCriteria5}
              />
            )}
            exact
          ></Route>
          <Route
            path="/matching-criteria-6"
            render={() => (
              <GoalMatch
                matching_criteria_6={this.state.matching_criteria_6}
                setMatchingCriteria6={this.setMatchingCriteria6}
              />
            )}
            exact
          ></Route>
          <Route
            path="/matching-criteria-7"
            render={() => (
              <Availability
                matching_criteria_7={this.state.matching_criteria_7}
                setMatchingCriteria7={this.setMatchingCriteria7}
              />
            )}
            exact
          ></Route>
          <Route
            path="/account-links"
            render={() => <AccountLinks resetState={this.resetState} />}
            exact
          ></Route>
          <Route path="/dashboard" component={Dashboard} />
          {/* Test */}
          <Route path="/loader" component={GooLoader} exact />
          {/* <Route path="/testing" component={TestPage} /> */}
          <Route component={NotFound} />
        </Switch>
      </div>
    );
  }
}

export default App;
